import {createFileRoute} from '@tanstack/react-router'

import DeploymentsScreen from '@protected/deployments'

export const Route = createFileRoute('/_protected/deployments')({component: DeploymentsScreen})
